'use client';

import * as React from 'react';
import { useState } from 'react';
import { EyeIcon, EyeOffIcon } from 'lucide-react';

import { InputGroup, InputGroupAddon, InputGroupButton, InputGroupInput } from './input-group';

interface PasswordInputProps extends React.ComponentProps<'input'> {
  hideLabel?: string;
  showLabel?: string;
}

function PasswordInput({
  hideLabel = 'Hide password',
  showLabel = 'Show password',
  ...props
}: PasswordInputProps) {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  return (
    <InputGroup>
      <InputGroupInput type={isPasswordVisible ? 'text' : 'password'} {...props} />
      <InputGroupAddon align="inline-end">
        <InputGroupButton
          size="icon-xs"
          variant="link"
          className="justify-center hover:bg-transparent"
          aria-label={isPasswordVisible ? hideLabel : showLabel}
          aria-pressed={isPasswordVisible}
          onClick={() => {
            setIsPasswordVisible((visible) => !visible);
          }}
        >
          {isPasswordVisible ? <EyeOffIcon /> : <EyeIcon />}
        </InputGroupButton>
      </InputGroupAddon>
    </InputGroup>
  );
}

export { PasswordInput };
